import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-my-registrations-action-cell',
  standalone: false,
  templateUrl: './my-registrations-action-cell.component.html',
  styleUrls: ['./my-registrations-action-cell.component.css']
})
export class MyRegistrationsActionCellComponent {
  @Input() row!: { renewLabel?: string };
  @Input() onRenew!: () => void;

  handleRenewClick(): void {
    this.onRenew?.();
  }
}
